import { defineMessages } from 'react-intl'

export default defineMessages({
  genericErrorTitle: {
    id: 'saveExpenseDraftPresenter.genericErrorTitle',
    defaultMessage: 'Error',
  },
  genericError: {
    id: 'saveExpenseDraftPresenter.genericError',
    defaultMessage: 'There was an error saving your draft. Please try again.',
  },
})
